module.exports = __webpack_public_path__ + "img/picto-user-claim.c55920c6.svg";